import { render, staticRenderFns } from "./themeTab.vue?vue&type=template&id=beddc01a&lang=pug"
import script from "./themeTab.vue?vue&type=script&lang=js"
export * from "./themeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports